import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Button,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import config from "../../config/config";
import "./testimonials.scss";

function TestimonialsList() {
  const navigate = useNavigate();
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const breadcrumbItems = [
    { title: "Testimonials", link: "#" },
    { title: "Testimonials List", link: "#" },
  ];

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const getPhotoUrl = (photo) => {
    if (!photo) return null;
    if (photo.startsWith("http") || photo.startsWith("data:")) return photo;
    const baseUrl = config.API_BASE_URL.replace(/\/api\/?$/, "");
    return photo.startsWith("/") ? `${baseUrl}${photo}` : `${baseUrl}/uploads/${photo}`;
  };

  const fetchTestimonials = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${config.API_BASE_URL}/testimonials`, {
        headers: { "ngrok-skip-browser-warning": "true" },
      });
      if (response.ok) {
        const data = await response.json();
        setTestimonials(
          Array.isArray(data)
            ? data
            : data.testimonials || data.data || []
        );
      } else {
        setTestimonials([]);
      }
    } catch (err) {
      console.error("Error fetching testimonials:", err);
      setError(err.message);
      setTestimonials([]);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (testimonial) => {
    navigate(`/edit-testimonial/${testimonial._id || testimonial.id}`, {
      state: { testimonial },
    });
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this testimonial?")) {
      try {
        const response = await fetch(`${config.API_BASE_URL}/testimonials/${id}`, {
          method: "DELETE",
          headers: { "ngrok-skip-browser-warning": "true" },
        });
        if (response.ok) {
          setTestimonials(testimonials.filter((t) => (t._id || t.id) !== id));
        } else {
          console.error("Failed to delete testimonial");
        }
      } catch (err) {
        console.error("Error deleting testimonial:", err);
      }
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Testimonials List"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-end mb-4">
                    <Link to="/create-testimonial">
                      <Button color="primary">
                        <i className="ri-add-line align-middle me-1"></i> Add Testimonial
                      </Button>
                    </Link>
                  </div>

                  {loading ? (
                    <div className="text-center py-4">Loading testimonials...</div>
                  ) : (
                    <div className="table-responsive">
                      <Table className="table table-centered table-nowrap mb-0">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Photo</th>
                            <th>Title</th>
                            <th>Tag</th>
                            <th>Person Name</th>
                            <th>Designation</th>
                            <th>Message</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {testimonials.length === 0 ? (
                            <tr>
                              <td colSpan="8" className="text-center py-4">
                                No testimonials found.
                              </td>
                            </tr>
                          ) : (
                            testimonials.map((item, index) => {
                              const photoUrl = getPhotoUrl(item.photo);
                              const personName = item.person_name || item.personName || item.name;
                              return (
                                <tr key={item._id || item.id || index}>
                                  <td>{item._id || item.id || index + 1}</td>
                                  <td>
                                    {photoUrl ? (
                                      <img
                                        src={photoUrl}
                                        alt={personName || "Photo"}
                                        className="testimonial-avatar"
                                      />
                                    ) : (
                                      <div className="avatar-xs">
                                        <span className="avatar-title rounded-circle bg-primary-subtle text-primary fw-bold">
                                          {personName ? personName.charAt(0).toUpperCase() : "T"}
                                        </span>
                                      </div>
                                    )}
                                  </td>
                                  <td className="fw-semibold">{item.title || "N/A"}</td>
                                  <td>
                                    {item.tag ? (
                                      <span className="testimonial-tag">{item.tag}</span>
                                    ) : (
                                      "N/A"
                                    )}
                                  </td>
                                  <td>{personName || "N/A"}</td>
                                  <td>{item.designation || "N/A"}</td>
                                  <td style={{ maxWidth: "250px", whiteSpace: "normal", wordWrap: "break-word" }}>
                                    {item.message || "N/A"}
                                  </td>
                                  <td>
                                    <button
                                      className="testimonial-action-buttons me-2 text-primary"
                                      onClick={() => handleEdit(item)}
                                      title="Edit"
                                    >
                                      <i className="ri-pencil-fill"></i>
                                    </button>
                                    <button
                                      className="testimonial-action-buttons text-danger"
                                      onClick={() => handleDelete(item._id || item.id)}
                                      title="Delete"
                                    >
                                      <i className="ri-delete-bin-fill"></i>
                                    </button>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default TestimonialsList;
